module.exports = __webpack_public_path__ + "static/img/fullscreen-image_explore-your-options_en_600.0f7369f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/fullscreen-image_explore-your-options_en_600.png
// module id = BEpr
// module chunks = 0